<form [formGroup]="form">
  <div class="p-fluid">
    <!-- Broj saglasnosti -->
    <kodit-text-input-field
      [formCtrl]="form.controls.brojSaglasnosti!"
      formCtrlId="brojSaglasnosti"
      formCtrlLabel="Broj saglasnosti"
    ></kodit-text-input-field>
  </div>
</form>
